import React, { Component } from 'react';
import { observer } from 'mobx-react';
import ReconQueryWidget from './ReconQueryWidget';

const defaultWidgetTitle = 'Devices with Highest Memory';

const QUERY = {
  use_kmetrics: true,
  show_overlay: false,
  show_total_overlay: false,
  kmetrics: {
    measurement: '/system/memory',
    dimensions: ['device_name'],
    metrics: [
      {
        name: 'utilization',
        type: 'gauge'
      }
    ],
    merge: {
      aggregate: 'avg',
      dimensions: ['index']
    },
    range: {
      lookback: 'PT1800S'
    },
    window: {
      size: 0,
      fn: {
        utilization: 'last'
      }
    },
    rollups: {
      last_utilization: {
        metric: 'utilization',
        aggregate: 'last'
      }
    },
    sort: [
      {
        name: 'last_utilization',
        direction: 'desc'
      }
    ],
    limit: 10,
    includeTimeseries: 10,
    viz: {
      metric: 'utilization',
      rollup: 'last_utilization',
      type: 'table'
    }
  }
};

@observer
class ReconMEMWidget extends Component {
  static defaultProps = {
    config: {
      query: QUERY
    }
  };

  render() {
    return (
      <ReconQueryWidget
        {...this.props}
        defaultWidgetTitle={defaultWidgetTitle}
        showDefaultOptions={false}
        hideTotalRow
        showSparklines
      />
    );
  }
}

export default ReconMEMWidget;
